module.exports = __webpack_public_path__ + "static/img/zhangyutian.3e19230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor/zhangyutian.jpg
// module id = a7ZP
// module chunks = 1